import { render, staticRenderFns } from "./ChallengeWinnersModal.vue?vue&type=template&id=55c02748"
import script from "./ChallengeWinnersModal.vue?vue&type=script&lang=js"
export * from "./ChallengeWinnersModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports